import React from 'react';
import { cn } from '@/utils/tailwind';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';

type LayoutTableControllerProps = {
  children: React.ReactNode;
  noPX?: boolean;
  className?: string;
};

const LayoutTableController = ({
  children,

  className,
}: LayoutTableControllerProps) => {
  const isPreviewMode = useMembershipPreviewMode();

  // 테이블 카드(Figma 1520-11011)의 상단부: border + rounded-t 가 여기서 시작하고
  // 하단 LayoutTables(카드 본문)가 border-x 를 이어받는다.
  // 높이는 --order-controller-h 로 보간(compact 시에도 52px 이상 유지). 폴백 84px.
  return (
    <div
      className={cn(
        'grid min-w-0 gap-[20px]',
        'rounded-t-[20px] border-x border-t border-gr-200 bg-white px-[20px]',
        className,
      )}
      style={{ height: 'var(--order-controller-h, 84px)' }}
      data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
    >
      <div
        className="scrollbar flex w-full min-w-0 items-center justify-between gap-[20px] overflow-x-auto"
        style={{ height: 'var(--order-controller-h, 84px)' }}
      >
        {children}
      </div>
    </div>
  );
};

export default LayoutTableController;
